'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const RainyIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.8227 17.75L10.7773 20.25M6.8 17.75L5.75 20.25M16.8228 17.75L15.7773 20.25M9.42188 14.25H16.125C18.4032 14.25 20.25 12.3777 20.25 10.0682C20.25 7.75863 18.4032 5.88636 16.125 5.88636C15.5908 5.88636 15.0803 5.98932 14.6117 6.17673C13.7313 4.15838 11.7388 2.75 9.42188 2.75C6.28939 2.75 3.75 5.32436 3.75 8.5C3.75 11.6756 6.28939 14.25 9.42188 14.25Z",
        stroke: "currentColor",
        strokeLinecap: "square"
      }
    )
  }
);
const VpRainyIcon = forwardRef(RainyIcon);

export { VpRainyIcon as default };
